import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/main.scss";
import productData from "../Datas/productData";

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="main">
      <Header />

      <main>
        {/* 1 */}
        <div className="main_box1">
          <Link onClick={toTop} to="/shop">
            <img src="/main/main1.webp" alt="product" />
          </Link>
        </div>
        {/* 2 */}
        <div className="promo-banner">
          <div className="promo-inner">
            <div className="promo-text">EXTRA 10% OFF EVERYTHING*</div>
            <div className="promo-sub">
              USE CODE: <strong>EXTRA</strong>
            </div>
          </div>
        </div>

        <section className="collections">
          <h2 className="collections-title">SHOP BY COLLECTION</h2>

          <div className="collection-grid">
            <Link onClick={toTop} to="/shop" className="collection-card">
              <img src="/main/main2-1.webp" alt="New Season" />
              <div className="card-overlay">
                <div className="card-content">
                  <h3>NEW SEASON</h3>
                  <button className="shop-now">SHOP NOW</button>
                </div>
              </div>
            </Link>

            <Link onClick={toTop} to="/shop" className="collection-card">
              <img src="/main/main2-2.webp" alt="Date Night" />
              <div className="card-overlay">
                <div className="card-content">
                  <h3>DATE NIGHT</h3>
                  <button className="shop-now">SHOP NOW</button>
                </div>
              </div>
            </Link>

            <Link onClick={toTop} to="/shop" className="collection-card">
              <img src="/main/main2-3.webp" alt="Lover Girl" />
              <div className="card-overlay">
                <div className="card-content">
                  <h3>LOVER GIRL</h3>
                  <button className="shop-now">SHOP NOW</button>
                </div>
              </div>
            </Link>

            <Link onClick={toTop} to="/shop" className="collection-card">
              <img src="/main/main2-4.webp" alt="Reset" />
              <div className="card-overlay">
                <div className="card-content">
                  <h3>RESET</h3>
                  <button className="shop-now">SHOP NOW</button>
                </div>
              </div>
            </Link>

            <Link onClick={toTop} to="/shop" className="collection-card">
              <img src="/main/main2-5.webp" alt="Featured" />
              <div className="card-overlay">
                <div className="card-content">
                  <h3>FEATURED</h3>
                  <button className="shop-now">SHOP NOW</button>
                </div>
              </div>
            </Link>
          </div>
        </section>

        {/* 3 */}
        <section className="badges-row-wrap">
          <div className="badges-row">
            <div className="badge-circle">
              <img alt="" src="/main/main3-1.webp" />
            </div>

            <div className="badge-circle">
              <img alt="" src="/main/main3-2.webp" />
            </div>

            <div className="badge-circle">
              <img alt="" src="/main/main3-3.webp" />
            </div>

            <div className="badge-circle">
              <img alt="" src="/main/main3-4.webp" />
            </div>

            <div className="badge-circle">
              <img alt="" src="/main/main3-5.webp" />
            </div>

            <div className="badge-circle">
              <img alt="" src="/main/main3-6.webp" />
            </div>

            <div className="badge-circle">
              <img alt="" src="/main/main3-7.webp" />
            </div>
          </div>
        </section>

        {/* 4 */}
        <section className="trending">
          <div className="trending-inner">
            <div className="trending-head">
              <div>
                <h2>Trending Now</h2>
                <p className="trending-desc">
                  From the not-so basics to the latest trending styles shop our
                  top picks.
                </p>
              </div>
            </div>

            <div className="trending-grid">
              {productData.slice(0, 5).map((product) => {
                const price = parseFloat(product.price) || 0;
                const oldPrice = (price * 1.2).toFixed(2);
                const discount = Math.round(
                  ((price - price * 1.2) / (price * 1.2)) * 100
                );
                return (
                  <Link
                    onClick={toTop}
                    to={`/shopDetails/${product.id}`}
                    className="product-card"
                    key={product.id}
                  >
                    <div className="product-media">
                      <img src={product.image} alt={product.name} />
                    </div>
                    <div className="product-meta">
                      <div className="brand">
                        {product.name.split(" ")[0].toLowerCase()}
                      </div>
                      <div className="title">{product.name}</div>
                      <div className="price-row">
                        <div className="price">£{price.toFixed(2)}</div>
                        <div className="old-price">£{oldPrice}</div>
                        <div className="discount">{Math.abs(discount)}%</div>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </section>

        {/* 5 */}
        <div className="main_box1" style={{ height: "90px" }}>
          <Link onClick={toTop} to="/shop">
            <img src="/main/main4.webp" alt="product" />
          </Link>
        </div>

        {/* 6 */}
        <section className="categories">
          <div className="categories-inner">
            <div className="category-grid">
              <Link onClick={toTop} to="/shop" className="category-card">
                <img src="/main/main5-1.webp" alt="Cosy Shop" />
                <div className="category-caption">COSY SHOP</div>
              </Link>

              <Link onClick={toTop} to="/shop" className="category-card">
                <img src="/main/main5-2.webp" alt="Denim" />
                <div className="category-caption">DENIM</div>
              </Link>

              <Link onClick={toTop} to="/shop" className="category-card">
                <img src="/main/main5-3.webp" alt="Active" />
                <div className="category-caption">ACTIVE</div>
              </Link>

              <Link onClick={toTop} to="/shop" className="category-card">
                <img src="/main/main5-4.webp" alt="Basics" />
                <div className="category-caption">BASICS</div>
              </Link>

              <Link onClick={toTop} to="/shop" className="category-card">
                <img src="/main/main5-5.webp" alt="Winter Sun" />
                <div className="category-caption">WINTER SUN</div>
              </Link>

              <Link onClick={toTop} to="/shop" className="category-card">
                <img src="/main/main5-6.webp" alt="Stripes" />
                <div className="category-caption">STRIPES</div>
              </Link>
            </div>
          </div>
        </section>

        {/* 7 */}
        <div className="main_box1" style={{ height: "600px" }}>
          <Link onClick={toTop} to="/shop">
            <img src="/main/main6.webp" alt="product" />
          </Link>
        </div>

        <div className="main_box1" style={{ height: "90px" }}>
          <Link onClick={toTop} to="/shop">
            <img src="/main/main7.webp" alt="product" />
          </Link>
        </div>

        {/* 8 */}
        <section className="brands">
          <div className="brands-inner">
            <div className="brand-grid">
              <Link onClick={toTop} to="/shop" className="brand-card">
                <img src="/main/main8-1.webp" alt="Quiz" />
              </Link>

              <Link onClick={toTop} to="/shop" className="brand-card">
                <img src="/main/main8-2.webp" alt="Boventraix" />
              </Link>

              <Link onClick={toTop} to="/shop" className="brand-card">
                <img src="/main/main8-3.webp" alt="PrettyLittleThing" />
              </Link>

              <Link onClick={toTop} to="/shop" className="brand-card">
                <img src="/main/main8-4.webp" alt="Nasty Gal" />
              </Link>

              <Link onClick={toTop} to="/shop" className="brand-card">
                <img src="/main/main8-5.webp" alt="MISSPAP" />
              </Link>

              <Link onClick={toTop} to="/shop" className="brand-card">
                <img src="/main/main8-6.webp" alt="Warehouse" />
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Main;
